import { findClassModule } from '../class-mapper';
/** @component Static Classes */
export const quickAccessMenuClasses = findClassModule((m) => m.Title && m.QuickAccessMenu && m.BatteryDetailsLabels);
/** @component Static Classes */
export const scrollPanelClasses = findClassModule((m) => m.ScrollPanel);
/** @component Static Classes */
export const gamepadDialogClasses = findClassModule((m) => m.GamepadDialogContent && !m.BindingButtons);
/** @component Static Classes */
export const quickAccessControlsClasses = findClassModule((m) => m.BatteryPercentageLabel && m.PanelSection && !m['vr-dashboard-bar-height'] && !m.QuickAccessMenu && !m.QuickAccess && !m.PerfProfileInfo);
/** @component Static Classes */
export const updaterFieldClasses = findClassModule((m) => m.OOBEUpdateStatusContainer);
/** @component Static Classes */
export const playSectionClasses = findClassModule((m) => m.PlayBarDetailLabel);
/** @component Static Classes */
export const gamepadSliderClasses = findClassModule((m) => m.SliderControlPanelGroup);
/** @component Static Classes */
export const appDetailsHeaderClasses = findClassModule((m) => m.TopCapsule);
/** @component Static Classes */
export const appDetailsClasses = findClassModule((m) => m.HeaderLoaded);
/** @component Static Classes */
export const gamepadUIClasses = findClassModule((m) => m.BasicUiRoot);
/** @component Static Classes */
export const gamepadTabbedPageClasses = findClassModule((m) => m.GamepadTabbedPage);
/** @component Static Classes */
export const gamepadContextMenuClasses = findClassModule((m) => m.BasicContextMenuModal);
/** @component Static Classes */
export const achievementListClasses = findClassModule((m) => m.AchievementListItemBase && !m.Page);
/** @component Static Classes */
export const achievementPageClasses = findClassModule((m) => m.AchievementListItemBase && m.Page);
/** @component Static Classes */
export const mainMenuAppRunningClasses = findClassModule((m) => m.AppRunningControls && m.OverlayAchievements);
/** @component Static Classes */
export const basicAppDetailsSectionStylerClasses = findClassModule((m) => m.AppDetailsRoot);
/** @component Static Classes */
export const steamSpinnerClasses = findClassModule((m) => m.SpinnerLoaderContainer);
/** @component Static Classes */
export const footerClasses = findClassModule((m) => m.QuickAccessFooter);
/** @component Static Classes */
export const appActionButtonClasses = findClassModule((m) => m.PlayButtonContainer);
/** @component Static Classes */
export const libraryAssetImageClasses = findClassModule((m) => m.LongTitles && m.GreyBackground);
/** @component Static Classes */
export const gamepadLibraryClasses = findClassModule((m) => m.GamepadLibrary);
/** @component Static Classes */
export const focusRingClasses = findClassModule((m) => m.FocusRingRoot);
/** @component Static Classes */
export const searchBarClasses = findClassModule((m) => m.SearchAndTitleContainer);
/** @component Static Classes */
export const mainBrowserClasses = findClassModule((m) => m.MainBrowserContainer);
/**
 * @component Static Classes
 * @deprecated please use quickAccessMenuClasses instead
 */
export const staticClasses = quickAccessMenuClasses;
/**
 * @component Static Classes
 * @deprecated please use scrollPanelClasses instead
 */
export const scrollClasses = scrollPanelClasses;
/**
 * @component Static Classes
 * @deprecated please use achievementListClasses instead
 */
export const achievementClasses = achievementListClasses;
